import React, {Fragment} from "react";

const ReadOnlyInput = ({name, value, label}) =>
{
    const renderLabel = ( labelText ) =>
    {
        if ( labelText !== null && labelText !== undefined && labelText !== '')
        {
            return <label key='lbl' className='col-form-label' htmlFor={name}>{labelText}</label>
        }
    }

    const renderInput = () =>
    {
        const style = {
            borderColor: '#ecf3f9',
            backgroundColor: '#f3f3f3',
            paddingLeft: '5px',
            color: '#428bcd'
        }

        return <div className='form-control' style={style}>{value}</div>
    }


    return (
        <Fragment>
            { renderLabel (label) }
            { renderInput ()}
        </Fragment>
    )
}

export default ReadOnlyInput ;
